import request from '../../config/axiosConfig';
import {
  GET_ALL_BLOCKS_VIDEO,
  GET_ALL_DISPLAY_PAGE,
  GET_ALL_TAGS_VIDEO,
  GET_ALL_VIDEOS,
  GET_CAMPAIGN_LIST,
  GET_DIMENSIONS_METRICS,
} from '../../constants/apiEndPoint';

export const getAllVideosRequest = async (data) => {
  const result = await request({
    url: GET_ALL_VIDEOS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getAllBlocksVideoRequest = async (data) => {
  const result = await request({
    url: GET_ALL_BLOCKS_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getAllTagsVideoRequest = async (data) => {
  const result = await request({
    url: GET_ALL_TAGS_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getAllDisplayPageRequest = async (data) => {
  const result = await request({
    url: GET_ALL_DISPLAY_PAGE,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getCampaignListRequest = async (data) => {
  const result = await request({
    url: GET_CAMPAIGN_LIST,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getListDimensionsAndMetricsRequest = async (data) => {
  const result = await request({
    url: GET_DIMENSIONS_METRICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};
